import {
  dollars,
  dollarsToNum,
  LoanApplication,
  PersonaParty,
  PreSubmitStatusOrder
} from "@oneethos/shared"
import { ConsumerAppFormData } from "."

const BORROWER_PERSONA_LICENSE_FIELDS = [
  'driversLicenseNo',
  'driversLicenseIssuingState',
  'driversLicenseIssueDate',
  'driversLicenseExpirationDate'
] as const

const COBORROWER_PERSONA_LICENSE_FIELDS = [
  'coDriversLicenseNo',
  'coDriversLicenseIssuingState',
  'coDriversLicenseIssueDate',
  'coDriversLicenseExpirationDate'
] as const

const hasPersonaLicenseValue = (value: unknown): boolean => {
  return value !== undefined && value !== null && value !== ''
}

export const personaVerificationFormPatch = (
  lapp: LoanApplication,
  party: PersonaParty
): Partial<ConsumerAppFormData> => {
  const patch: Partial<ConsumerAppFormData> = {}

  if (lapp.personaVerifications !== undefined) {
    patch.personaVerifications = lapp.personaVerifications
  }

  const licenseFields = party === 'co-borrower'
    ? COBORROWER_PERSONA_LICENSE_FIELDS
    : BORROWER_PERSONA_LICENSE_FIELDS

  for (const field of licenseFields) {
    const value = lapp[field]
    if (hasPersonaLicenseValue(value)) {
      patch[field] = value
    }
  }

  return patch
}

export const formDataToLoanApp = (formData): LoanApplication => {
  const { ...lapp } = formData

  lapp.customerName = `${lapp.firstName} ${lapp.lastName}`
  if (typeof lapp.loanAmount === 'string') {
    lapp.loanAmount = dollarsToNum(lapp.loanAmount)
  }

  if (typeof lapp.avgMonthlyUtilityBill === 'string') {
    lapp.avgMonthlyUtilityBill = dollarsToNum(lapp.avgMonthlyUtilityBill)
  }

  return lapp
}

export const lappToFormData = (lapp: LoanApplication): Partial<ConsumerAppFormData> => {
  return {
    preSubmitStatus: PreSubmitStatusOrder[0],
    // important to initialize these to false to prevent false approvals
    agreesToTermsAndConditions: false,
    agreesToProceedWithHardCreditInquiry: false,
    installedAtDifferentLocation: 'no',
    ...lapp,
    useAutoDebit: lapp.useAutoDebit || 'yes',
    incentive: lapp.incentive,
    loanAmount: dollars(lapp.loanAmount?.toString() || ''),
    solarCost: dollars(lapp.solarCost?.toString()),
    adders: lapp.adders?.map(adder => ({
      ...adder,
      amount: dollars(adder.amount?.toString())
    })),
    avgMonthlyUtilityBill: (
      lapp.avgMonthlyUtilityBill ?
        dollars(lapp.avgMonthlyUtilityBill?.toString()) :
        undefined
    )
  }
}
